interface HomeSectionTitleProps {
  eyebrow: string;
  titleBefore: string;
  titleAccent: string;
  accentColor: string;
  titleColor: string;
  className?: string;
}

export function HomeSectionTitle({
  eyebrow,
  titleBefore,
  titleAccent,
  accentColor,
  titleColor,
  className = '',
}: HomeSectionTitleProps) {
  return (
    <div className={`wl5-home-section-head ${className}`.trim()}>
      <p className="wl5-home-section-eyebrow" style={{ color: accentColor }}>
        {eyebrow}
      </p>
      <h2 className="wl5-home-section-title" style={{ color: titleColor }}>
        {titleBefore}{' '}
        <span className="wl5-home-section-accent" style={{ color: accentColor }}>
          {titleAccent}
          <span
            className="wl5-home-section-underline"
            style={{ backgroundColor: accentColor }}
            aria-hidden="true"
          />
        </span>
      </h2>
    </div>
  );
}
